import { TABLES_KEYS } from 'features/ai-assistant/constants';
import strings from 'strings';

export const COPIES = strings.ai.generators.prospectingAssistant.drawer.table;
export const TABLE_KEY = TABLES_KEYS.aiProspectingAssistantResults;
export const ORDER_BY_OPTIONS = { column: 'id', direction: 'desc' };
export const DEFAULT_PER_PAGE = 20;
const getMinWidthCellProps = ({ minWidthValue }) => ({ style: { minWidth: minWidthValue } });

export const PROSPECTING_COLUMNS = [
  {
    name: 'id',
    options: {
      filter: false,
      display: 'excluded'
    }
  },
  {
    name: 'fullName',
    label: COPIES.columns.fullName,
    options: {
      sort: false,
      display: true,
      setCellHeaderProps: () => getMinWidthCellProps({ minWidthValue: 150 })
    }
  },
  {
    name: 'websitesLinkedin',
    label: COPIES.columns.linkedinUrl,
    options: {
      sort: false,
      display: true,
      renderer: {
        id: 'website'
      }
    }
  },
  {
    name: 'headline',
    label: COPIES.columns.headline,
    options: {
      sort: false,
      display: true,
      setCellHeaderProps: () => getMinWidthCellProps({ minWidthValue: 200 })
    }
  },

  {
    name: 'jobTitle',
    label: COPIES.columns.title,
    options: {
      sort: false,
      display: true,
      setCellHeaderProps: () => getMinWidthCellProps({ minWidthValue: 200 })
    }
  },
  {
    name: 'department',
    label: COPIES.columns.department,
    options: {
      sort: false,
      display: true,
      setCellHeaderProps: () => getMinWidthCellProps({ minWidthValue: 200 })
    }
  },
  {
    name: 'locationRawAddress',
    label: COPIES.columns.location,
    options: {
      sort: false,
      display: true,
      setCellHeaderProps: () => getMinWidthCellProps({ minWidthValue: 150 })
    }
  },
  {
    name: 'companyName',
    label: COPIES.columns.companyName,
    options: {
      sort: false,
      display: true,
      setCellHeaderProps: () => getMinWidthCellProps({ minWidthValue: 150 })
    }
  },
  {
    name: 'companyIndustry',
    label: COPIES.columns.companyIndustry,
    options: {
      sort: false,
      display: true,
      setCellHeaderProps: () => getMinWidthCellProps({ minWidthValue: 200 })
    }
  },
  {
    name: 'companyLocationHqFullAddress',
    label: COPIES.columns.companyLocationHqFullAddress,
    options: {
      sort: false,
      display: true,
      setCellHeaderProps: () => getMinWidthCellProps({ minWidthValue: 250 })
    }
  },
  {
    name: 'companyLinkedinUrl',
    label: COPIES.columns.companyLinkedinUrl,
    options: {
      sort: false,
      display: true,
      renderer: {
        id: 'website'
      }
    }
  },
  {
    name: 'companyWebsite',
    label: COPIES.columns.companyWebsite,
    options: {
      sort: false,
      display: true,
      renderer: {
        id: 'website'
      }
    }
  }
];
